<mat-card class="filter settingHeader">
  <div class="name">
    Manage Task Category

    <button mat-icon-button color="primary" *ngIf="showOptionForDelete" (click)="deleteMultipleTaskCategory()">
      <mat-icon>delete</mat-icon>
    </button>

  </div>



  <div class="quickAction">

    <!-- <mat-form-field appearance="">
      <mat-label>Search items in task status</mat-label>
      <input matInput type="text" [(ngModel)]="value" (keyup)="$event.keyCode == 13 ? Search($event.target.value) : ($event.target.value==''?Search($event.target.value):null)" >
      <button mat-button *ngIf="value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
        <mat-icon>close</mat-icon>
      </button>
      <button  *ngIf="!value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
        <mat-icon>search</mat-icon>
      </button>
    </mat-form-field> -->

    <div class="">
      <button mat-flat-button color="primary" (click)="openDialogAddWithRef(myAddDialog)"> Add Task Category </button>
    </div>

  </div>
</mat-card>


<div class="documents">

  <mat-card class="example-list rowholder" *ngIf="!ShowNoRecordFound">
    <div class="fieldRow head">
      <span class="moveicon"></span>
      <span class="moveicon"></span>
      <span class="fieldName">Category Name</span>
      <span class="requried">Active/Inactive</span>
      <span class="editField">Edit</span>
      <!-- <span class="delete">Delete</span> -->
    </div>

    <div class="example-box fieldRow" *ngFor="let task of taskCategoryList">
      <span class="moveicon"></span>

      <mat-checkbox color="primary" (change)="selectRecordForDelete($event,task)">
      </mat-checkbox>

      <span class="fieldName">{{task.taskTemplateCategoryName}}</span>

      <span class="requried">
        <mat-slide-toggle color="primary" [checked]="task.isActive" (change)="UpdateStatusToggle(task,$event)">
        </mat-slide-toggle>
      </span>

      <span class="editField">
        <button mat-icon-button class="editbtn" (click)="UpdateTaskDialog(myUpdateDialog,task)">
          <mat-icon>edit</mat-icon>
        </button>
      </span>


    </div>

    <!-- <mat-paginator [pageIndex]="pageIndex" [pageSize]="pageSize" [length]="paginatorTotalLength" [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons  (page)="CallNextPrevPageData($event)"></mat-paginator> -->

  </mat-card>
  <div *ngIf="ShowNoRecordFound" class="noRecordFound">No Record Found</div>

</div>



<ng-template #myAddDialog>
  <form [formGroup]="formDialog">
    <h2 mat-dialog-title>
      Add Task Category
      <button mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>

    <mat-dialog-content class="mat-typography">
      <mat-form-field class="example-full-width">
        <mat-label>Category Name</mat-label>
        <input matInput [required]="true" maxlength="50" placeholder="Add category name"
          formControlName="categoryName" />
        <mat-error *ngIf="formDialog.get('categoryName').invalid &&
        (formDialog.get('categoryName').dirty ||
        formDialog.get('categoryName').touched)">
          <span>This field is mandatory.</span>
        </mat-error>
      </mat-form-field>

    </mat-dialog-content>

    <mat-dialog-actions class="dialog-actions">
      <button mat-button (click)="close()">Cancel</button>
      <button mat-flat-button color="primary" [disabled]="formDialog.invalid || !formDialog.dirty"
        (click)="AddTaskCategory(formDialog.value)">
        Save
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
          </mat-spinner></mat-icon>
      </button>
    </mat-dialog-actions>
    <app-loader></app-loader>
  </form>
</ng-template>


<ng-template #myUpdateDialog>
  <form [formGroup]="updateformDialog">
    <h2 mat-dialog-title>
      Update Task Category
      <button mat-icon-button (click)="closeUpdate()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>

    <mat-dialog-content class="mat-typography">
      <mat-form-field class="example-full-width">
        <mat-label>Category Name</mat-label>
        <input matInput [required]="true" maxlength="50" placeholder="update category name"
          formControlName="categoryName" />
        <mat-error *ngIf="updateformDialog.get('categoryName').invalid &&
        (updateformDialog.get('categoryName').dirty ||
        updateformDialog.get('categoryName').touched)">
          <span>This field is mandatory.</span>
        </mat-error>
      </mat-form-field>

    </mat-dialog-content>

    <mat-dialog-actions class="dialog-actions">
      <button mat-button (click)="closeUpdate()">Cancel</button>
      <button mat-flat-button color="primary" [disabled]="updateformDialog.invalid || !updateformDialog.dirty"
        (click)="UpdateTaskCategory(updateformDialog.value)">
        Update
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
          </mat-spinner></mat-icon>
      </button>
    </mat-dialog-actions>
    <app-loader></app-loader>
  </form>
</ng-template>


<app-loader></app-loader>